// Counts a feature use for Re:Vault's private visitor counter (shared/rv-count.js, inlined in each
// page's <head>). Names come from fixed lists the server checks: "tool:flashcards", "book",
// "setting:theme", "look:zen", "hall:math". Never a title, an address or anything typed.
// Pages without the counter (Study Hall) pass it to the app frame they're inside.
export function metric(name) {
	try {
		const f = window.__rvm || (window.parent !== window && window.parent.__rvm);
		if (typeof f === "function") f(name);
	} catch (e) { void e; }
}
